import React from 'react'
import { Nav } from '../Components/Nav'

import "./Team.css"
import { Footer } from '../Components/Footer'

const Team = () => {
    const tech = [
        {
            id: 1,
            title: "Priyanshu Kumar Panda",
            desg: "Technical Team",
            src: "https://res.cloudinary.com/desyzom9w/image/upload/v1694011461/tech/yyh3mrspa3top4xaoho4.jpg",
        },
        {
            id: 3,
            title: "Sai Ram Senapati",
            desg: "Technical Team",
            src: "https://res.cloudinary.com/desyzom9w/image/upload/v1694013597/tech/kmo9fzcnitad64vhrl2g.jpg",
        },
        {
            id: 2,
            title: "Biswajeet Behera",
            desg: "Technical Team",
            src: "https://res.cloudinary.com/desyzom9w/image/upload/v1694070442/tech/jnoozlrh6jkudco5ubkv.jpg",
        },
        {
            id: 4,
            title: "Sneha Sahu",
            desg: "Technical Team",
            src: "https://res.cloudinary.com/desyzom9w/image/upload/v1694011945/tech/ht1c2c8u72wh9acrjmgq.jpg",
        },
        {
            id: 5,
            title: "Pabitra Kumar Bebartta",
            desg: "Technical Team",
            src: "https://res.cloudinary.com/desyzom9w/image/upload/v1694011454/tech/v3k9fsbhtyld6nzyafti.jpg",
        },
        {
            id: 6,
            title: "Adarsh Agarwal",
            desg: "Technical Team",
            src: "https://res.cloudinary.com/desyzom9w/image/upload/v1694012094/tech/vjpcnvvy4hjror2blkjp.jpg",
        },
        {
            id: 7,
            title: "Vidit Kushwaha",
            desg: "Technical Team",
            src: "https://res.cloudinary.com/desyzom9w/image/upload/v1694012295/tech/ha0gsdyhngzgcrt09hoh.jpg",
        },
    ]

    const event = [
        {
            id: 1,
            title: "Brijesh Mishra",
            desg: "Event Management Team",
            src: "https://res.cloudinary.com/desyzom9w/image/upload/v1694010495/em/ydariugrgwteigehdba0.jpg",
        },
        {
            id: 2,
            title: "Siba Sankar Pradhan",
            desg: "Event Management Team",
            src: "https://res.cloudinary.com/desyzom9w/image/upload/v1694010494/em/f0jbuab0ud0dzeugiyc6.jpg",
        },
        {
            id: 3,
            title: "Mukesh Kumar Sahu",
            desg: "Event Management Team",
            src: "https://res.cloudinary.com/desyzom9w/image/upload/v1694010495/em/wuwdvqmcu2fwbrjcpk1p.jpg",
        },
        {
            id: 4,
            title: "Mahesh Prasad Sahu",
            desg: "Event Management Team",
            src: "https://res.cloudinary.com/desyzom9w/image/upload/v1694010498/em/f0ymsxd7lwkir0bmfav0.jpg",
        },

        {
            id: 5,
            title: "Pasupathi Nad",
            desg: "Event Management Team",
            src: "https://res.cloudinary.com/desyzom9w/image/upload/v1694010886/em/ddxyfmzr7doaxowkfoih.jpg",
        },
        {
            id: 6,
            title: "Banothu Nithiesh Naik ",
            desg: "Event Management Team",
            src: "https://res.cloudinary.com/desyzom9w/image/upload/v1694011068/em/ugb9p9hlsg5mzszfgfap.jpg",
        },
        {
            id: 7,
            title: "Harsh Baid",
            desg: "Event Management Team",
            src: "https://res.cloudinary.com/desyzom9w/image/upload/v1694013748/a7etzlad04pwe2uo2bx7.png",
        },
    ]

    const design = [
        {
            id: 1,
            title: "Asutosh Ranjan",
            desg: "Design & Video Editing Team",
            src: "https://res.cloudinary.com/desyzom9w/image/upload/v1694014531/design/pvtstjpyrjerpqigre3i.jpg",
        },
        {
            id: 2,
            title: "Biswaprakash Bahinipati",
            desg: "Design & Video Editing Team",
            src: "https://res.cloudinary.com/desyzom9w/image/upload/v1694011197/design/lutfrxemxyia2c4wkrie.jpg",
        },
        {
            id: 3,
            title: "Rahul Ranjan Dash",
            desg: "Design & Video Editing Team",
            src: "https://res.cloudinary.com/desyzom9w/image/upload/v1694011197/design/fghwgwvmrwidera9pniq.jpg",
        },
        {
            id: 4,
            title: "Sabitu Datta",
            desg: "Design & Video Editing Team",
            src: "https://res.cloudinary.com/desyzom9w/image/upload/v1694011198/design/krhpn9tq4ztnjnlnacmw.jpg",
        },
        {
            id: 5,
            title: "Shubham Padaval",
            desg: "Design & Video Editing Team",
            src: "https://res.cloudinary.com/desyzom9w/image/upload/v1694011198/design/bitjvekhvcb8ngzabxq2.jpg",
        },
    ]

    const travel = [
        {
            id: 1,
            title: "Jagnyaraj Pattnaik",
            desg: "Travel & Logistic Team",
            src: "https://res.cloudinary.com/desyzom9w/image/upload/v1694012565/travel/uvwgei3bi51z1dqsw8ap.jpg",
        },
        {
            id: 2,
            title: "Soumyakanta Prusty",
            desg: "Travel & Logistic Team",
            src: "https://res.cloudinary.com/desyzom9w/image/upload/v1694017235/travel/f4dysznabf9wcmu3yxjq.jpg",
        },
        {
            id: 3,
            title: "Shreyas Pradhan",
            desg: "Travel & Logistic Team",
            src: "https://res.cloudinary.com/desyzom9w/image/upload/v1694012788/travel/mczopvrhjricikxwwoey.jpg",
        }
    ]

    const pr = [
        {
            id: 1,
            title: "Ansuman Mahapatra",
            desg: "PR Team",
            src: "https://res.cloudinary.com/desyzom9w/image/upload/v1694012987/pr/uamtfzaxzwqagfum7yix.jpg",
        },
        {
            id: 2,
            title: "Abhinav Arunesh",
            desg: "PR Team",
            src: "https://res.cloudinary.com/desyzom9w/image/upload/v1694012984/pr/zlzw4mjrqjnkkpyj5ury.jpg",
        },
        {
            id: 3,
            title: "Jharendra Sunani",
            desg: "PR Team",
            src: "https://res.cloudinary.com/dtp5uqey3/image/upload/v1694025475/Roots/image_zvnlv4.jpg",
        },
    ]

    const guest = [
        {
            id: 1,
            title: "Sonali Pradhan",
            desg: "Guest Hospitality & Workshop Team",
            src: "https://res.cloudinary.com/desyzom9w/image/upload/v1694025032/guest/dzj6leyt8hr43fjcxxcq.jpg",
        },
        {
            id: 2,
            title: "Aiswarya R Behera",
            desg: "Guest Hospitality & Workshop Team",
            src: "https://res.cloudinary.com/desyzom9w/image/upload/v1694013176/guest/bnvbxwcsnk3jpi8xhtpv.jpg",
        },
        {
            id: 3,
            title: "Prayag Sahoo",
            desg: "Guest Hospitality & Workshop Team",
            src: "https://res.cloudinary.com/desyzom9w/image/upload/v1694013312/guest/gcfyzqz3i8nufvqkcgat.jpg",
        },
    ]

    return (
        <>
            <Nav />
            <div className='w-full h-full bg-[#fffefe] pt-16 flex flex-col justify-center items-center pb-10 -z-50 font-outfit'>
                <div className='-mt-24'>
                    <img src='https://res.cloudinary.com/desyzom9w/image/upload/v1693996736/fmeb0lua1vkqysakqysh.png' alt="" />
                </div>
                <div className='flex flex-col justify-center items-center mt-16'>
                    <div className='flex flex-col items-center before:blur-md w-[85%] -z-0'>
                        <div className='text-5xl flex items-center justify-center font-bold font-[#595959]'>Our Patron</div>

                        <div className='bg-gray-300 shadow-xl backdrop-blur-[15px] w-fit flex items-center justify-center h-fit rounded-xl mt-6 py-12'>
                            <div className='flex items-center flex-wrap gap-8 justify-center pt'>
                                <div className="profile-card">
                                    <div className="img">
                                        <img src="https://res.cloudinary.com/desyzom9w/image/upload/v1694010209/hi7ddugpa2xsgvalqljp.jpg" alt="" />
                                    </div>
                                    <div className="caption">
                                        <h3>K. Umamaheswar Rao</h3>
                                        <p>Director</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className='flex flex-col items-center before:blur-md mt-8 w-[85%]'>
                        <div className='text-5xl flex items-center justify-center font-bold font-[#595959]'>SAC Officials</div>

                        <div className='bg-gray-300 shadow-xl w-fit flex items-center justify-center h-fit rounded-xl mt-6 py-12'>
                            <div className='flex items-center flex-wrap gap-8 justify-center pt'>
                                <div className="profile-card my-3">
                                    <div className="img">
                                        <img src="https://res.cloudinary.com/desyzom9w/image/upload/v1694010277/rzexoampaobf65jwqxam.jpg" alt="" />
                                    </div>
                                    <div className="caption">
                                        <h3>Sidhartha S. Jena</h3>
                                        <p>Dean (SW)</p>
                                    </div>
                                </div>
                                <div className="profile-card">
                                    <div className="img">
                                        <img src="https://res.cloudinary.com/desyzom9w/image/upload/v1694010122/y5wtzq6n4ghzorc29hzv.jpg" alt="" />
                                    </div>
                                    <div className="caption">
                                        <h3>Rajeev Kumar Panda</h3>
                                        <p>SAC President</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className='text-7xl flex items-center justify-center font-bold font-[#595959] mt-10'>Core Team</div>

                    <div className='flex flex-col items-center before:blur-md mt-8 w-[85%] justify-center'>
                        <div className='text-4xl flex items-center justify-center font-bold font-[#595959] pb-6'>Technical Team</div>

                        <div className='bg-gray-300 shadow-xl w-fit flex items-center justify-center h-fit rounded-xl mt-6 py-14'>
                            <div className='flex items-center flex-wrap gap-8 justify-center pt'>
                                {tech.map(({ id, title, desg, src }) => (
                                    <div className="profile-card my-3" key={id}>
                                        <div className="img">
                                            <img src={src} alt="" />
                                        </div>
                                        <div className="caption">
                                            <h3>{title}</h3>
                                            <p>{desg}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>

                    <div className='flex flex-col items-center before:blur-md mt-8 w-[85%] justify-center'>
                        <div className='text-4xl flex items-center justify-center font-bold font-[#595959] pb-6'>Event Management Team</div>

                        <div className='bg-gray-300 shadow-xl w-fit flex items-center justify-center h-fit rounded-xl mt-6 py-14'>
                            <div className='flex items-center flex-wrap gap-8 justify-center pt'>
                                {event.map(({ id, title, desg, src }) => (
                                    <div className="profile-card my-3" key={id}>
                                        <div className="img">
                                            <img src={src} alt="" />
                                        </div>
                                        <div className="caption">
                                            <h3>{title}</h3>
                                            <p>{desg}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>

                    <div className='flex flex-col items-center before:blur-md mt-8 w-[85%] justify-center'>
                        <div className='text-4xl flex items-center justify-center font-bold font-[#595959] pb-6'>Design & Video Editing Team</div>

                        <div className='bg-gray-300 shadow-xl w-fit flex items-center justify-center h-fit rounded-xl mt-6 py-14'>
                            <div className='flex items-center flex-wrap gap-8 justify-center pt'>
                                {design.map(({ id, title, desg, src }) => (
                                    <div className="profile-card my-3" key={id}>
                                        <div className="img">
                                            <img src={src} alt="" />
                                        </div>
                                        <div className="caption">
                                            <h3>{title}</h3>
                                            <p>{desg}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>

                    <div className='flex flex-col items-center before:blur-md mt-8 w-[85%] justify-center'>
                        <div className='text-4xl flex items-center justify-center font-bold font-[#595959] pb-6'>Travel & Logistics Team</div>

                        <div className='bg-gray-300 shadow-xl w-fit flex items-center justify-center h-fit rounded-xl mt-6 py-14'>
                            <div className='flex items-center flex-wrap gap-8 justify-center pt'>
                                {travel.map(({ id, title, desg, src }) => (
                                    <div className="profile-card my-3" key={id}>
                                        <div className="img">
                                            <img src={src} alt="" />
                                        </div>
                                        <div className="caption">
                                            <h3>{title}</h3>
                                            <p>{desg}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>

                    <div className='flex flex-col items-center before:blur-md mt-8 w-[85%] justify-center'>
                        <div className='text-4xl flex items-center justify-center font-bold font-[#595959] pb-6'>PR Team</div>

                        <div className='bg-gray-300 shadow-xl w-fit flex items-center justify-center h-fit rounded-xl mt-6 py-14'>
                            <div className='flex items-center flex-wrap gap-8 justify-center pt'>
                                {pr.map(({ id, title, desg, src }) => (
                                    <div className="profile-card my-3" key={id}>
                                        <div className="img">
                                            <img src={src} alt="" />
                                        </div>
                                        <div className="caption">
                                            <h3>{title}</h3>
                                            <p>{desg}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>

                    <div className='flex flex-col items-center before:blur-md mt-8 w-[85%] justify-center'>
                        <div className='text-4xl flex items-center justify-center font-bold font-[#595959] pb-6'>Guest Hospitality & Workshop Team</div>

                        <div className='bg-gray-300 shadow-xl w-fit flex items-center justify-center h-fit rounded-xl mt-6 py-14'>
                            <div className='flex items-center flex-wrap gap-8 justify-center pt'>
                                {guest.map(({ id, title, desg, src }) => (
                                    <div className="profile-card my-3" key={id}>
                                        <div className="img">
                                            <img src={src} alt="" />
                                        </div>
                                        <div className="caption">
                                            <h3>{title}</h3>
                                            <p>{desg}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            <Footer />
        </>
    )
}

export default Team
